module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Island of Mora Mora: "), _c('br'), _vm._v("A Journey into Madagascar")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#preface"
    }
  }, [_vm._v("Preface")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-one-antananarivo"
    }
  }, [_vm._v("Chapter One: Antananarivo")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-two-diego-suarez",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two: Diego Suarez")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-three-diego-to-ambanja",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three: Diego to Ambanja")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-four-night-bus-to-mahajanga",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: Night Bus to Mahajanga")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-five-camp-indri",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: Camp Indri")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-six-sambava-to-maroantsetra",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: Sambava to Maroantsetra")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-seven-the-train-to-tana-maroantsetra-to-antananarivo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: The Train to Tana: Maroantsetra to Antananarivo")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-eight-the-land-of-the-invincible-multitude-antsirabe-fianarantsoa-and-manakara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: The Land of the Invincible Multitude: Antsirabe, Fianarantsoa and Manakara")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-nine-goat-circumcision-and-a-crayon-fence-the-last-road-to-toliara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: Goat, Circumcision and a Crayon Fence: The Last Road to Toliara")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0